import { useMutation } from '@tanstack/react-query';
import { VerifyEmailRequest } from '@/types/request/VerifyEmailRequest';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';

const useVerifyEmail = () => {
  const mutationFn = async (request: VerifyEmailRequest) => {
    return verifyEmail(request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useVerifyEmail;

async function verifyEmail(request: VerifyEmailRequest): Promise<void> {
  try {
    await BackendClient.post<BackendSuccessResponse<{ message: string }>>('/api/auth/verify-otp', request);

    return;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while verifying email address.');
  }
}
